module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 12c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4m0-6c-1.103 0-2 .896-2 2 0 1.102.897 2 2 2s2-.898 2-2c0-1.104-.897-2-2-2m8 14H4v-1c0-3.533 3.29-6 8-6s8 2.467 8 6v1zM6.16 18h11.68c-.6-1.808-2.834-3-5.842-3s-5.243 1.192-5.84 3z\" clip-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/svg/login.svg
// module id = 1527
// module chunks = 0